export function useLocalStorage() {
   const setStorage = (key: string, data: string) => {
      if (typeof window !== "undefined" && window.localStorage) {
         window.localStorage.setItem(key, data);
      }
   };

   const getStorage = (key: string): string | null => {
      if (import.meta.client) {
         const value = localStorage.getItem(key);
         // Don't return [object Object] strings
         if (value === "[object Object]" || value === "undefined") {
            return null;
         }
         return value;
      }
      return null;
   };

   const clearStorage = (key: string) => {
      if (typeof window !== "undefined") window.localStorage.removeItem(key);
   };

   const clearAllStorage = () => {
      if (typeof window !== "undefined") window.localStorage.clear();
   };

   return {
      setStorage,
      getStorage,
      clearStorage,
      clearAllStorage,
   };
}
